import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { useBatch } from "@/hooks/queries";
import { useSidePanel } from "@/modules/side-panel";

import DissociateComponent from "./Dissociate";
import { getFieldTranslationKey } from "./DissociateUtils";

const useInterventionsBatchDissociate = ({
  interventionsModels,
  dissociateField,
  dissociateModel,
  invalidateKeys,
}) => {
  const { t } = useTranslation();
  const { closeSidePanel } = useSidePanel();
  const {
    mutate,
    isPending: isLoading,
    isError,
    reset,
  } = useBatch("interventions", "update", { invalidateKeys });

  const questionText = useMemo(() => {
    const fieldKey = getFieldTranslationKey(dissociateField);
    return t(`intervention:batchDissociate:question:${fieldKey}`, {
      [fieldKey]: dissociateModel.name,
    });
  }, [dissociateField, dissociateModel]);

  const batchDissociateInterventions = () => {
    const interventionsIds = interventionsModels.map((model) => model.id);
    const data = { interventions: interventionsIds, [dissociateField]: null };
    mutate(data, { onSuccess: closeSidePanel });
  };

  return {
    questionText,
    buttonText: t("global:batchDissociate"),
    onDissociateClick: batchDissociateInterventions,
    onAlertCloseClick: reset,
    isLoading,
    isError,
  };
};

const InterventionsBatchDissociate = (props) => {
  const componentProps = useInterventionsBatchDissociate(props);

  return <DissociateComponent {...componentProps} />;
};

export default InterventionsBatchDissociate;
